<script>
export default {
  props: {
    filterItems: {
      type: Array,
      default: () => [],
      require: true,
    },
  },
  data: () => ({
    filter: {},
    pickerDate: {},
  }),
  methods: {
    handleFilterSearch() {
      for (const item in this.filter) {
        if (this.filter[item] === null || this.filter[item] === '') {
          delete this.filter[item]
        }
        if (typeof this.filter[item] === 'string') {
          this.filter[item] = this.filter[item].trim()
        }
      }
      this.$emit('filter', this.filter)
    },
    reset() {
      this.$refs.form.reset()
    },
    formatDate(key, date) {
      const [year, month, day] = date.split('-')
      this.filter[key] = `${year}/${month}/${day}`
    },
  },
}
</script>

<template>
  <v-row no-gutters class="pt-4">
    <v-col cols="12">
      <v-form ref="form" @submit.prevent="handleFilterSearch">
        <v-row>
          <v-col
            v-for="(item, i) in filterItems"
            :key="`group-${i}`"
            cols="6"
            md="3"
            sm="6"
          >
            <v-text-field
              v-if="item.as === 'text-field'"
              v-model="filter[item.key]"
              :label="$t(item.label)"
              dense
              clearable
              hide-details="auto"
              class="margin-input-search"
              :maxlength="item.maxlength"
            />
            <v-select
              v-else-if="item.as === 'select'"
              v-model="filter[item.key]"
              :label="$t(item.label)"
              flat
              :items="item.selectList"
              item-text="message"
              item-value="value"
              dense
              clearable
              hide-details="auto"
              class="custom__width-select"
            />
            <v-menu
              v-else-if="item.as === 'date-picker'"
              ref="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filter[item.key]"
                  :label="$t(item.label)"
                  prepend-icon="mdi-calendar"
                  readonly
                  dense
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="pickerDate[`${item.key}`]"
                no-title
                scrollable
                @change="formatDate(item.key, $event)"
              >
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" md="3" sm="6" class="mb-2">
            <v-btn
              color="#5198d7"
              class="white--text custom_width custom_height mr-1"
              type="submit"
              >{{ $t('search') }}</v-btn
            >
            <v-btn
              color="grey"
              class="white--text custom_height"
              type="button"
              @click="reset"
            >
              {{ $t('reset') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>
